const requestedByKey = new Set<string>();

export const requestSmsCountByCustomerOnce = (
    clientId: number,
    marketplaceId: number | undefined,
    request: () => void
): void => {
    const key = `${clientId}:${marketplaceId ?? ''}`;
    if (requestedByKey.has(key)) return;
    requestedByKey.add(key);
    request();
};
